import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, Image, Icon, Header, Label, Table, Sidebar, Button } from 'semantic-ui-react';
import i18next from 'i18next';
import SideEditor from '../../general/SideEditor';
import DeliveryEditor from './DeliveryEditor';
import { formatPrice } from '../../../helpers/format';
import { setEditedEntity, fetchMonthlyBreakdown } from '../../../actions';
import api from '../../../actions/api';

class CompanyDetails extends Component {

    componentWillMount() {
        if (this.props.company && this.props.company.id) {
            this.mountMonthlyBreakdown(this.props.company.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.company && nextProps.company.id !== this.props.company.id) {
            this.mountMonthlyBreakdown(nextProps.company.id);
        }
    }

    mountMonthlyBreakdown(id) {
        this.props.fetchMonthlyBreakdown(id, new Date());
    }

    editDeliveryInfo = () => {
        const { company } = this.props;

        if (company.deliveryInfo) {
            this.props.setEditedEntity('company', company);
            return;
        }

        const { address } = company;

        api.google.address(address, 'he').then(({ data }) => {
            const deliveryInfo = { fullAddress: address, contact: {} };

            if (data && data.results && data.results.length) {
                const result = data.results[0];

                deliveryInfo.fullAddress = result.formatted_address;

                result.address_components.forEach(component => {
                    if (component.types.includes('locality'))
                        deliveryInfo.city = component.long_name;
                    if (component.types.includes('route'))
                        deliveryInfo.street = component.long_name;
                    if (component.types.includes('street_number'))
                        deliveryInfo.streetNumber = component.long_name;
                });
            }

            this.props.setEditedEntity('company', { ...company, deliveryInfo });
        }).catch((err) => {
            this.props.setEditedEntity('company', {
                ...company,
                deliveryInfo: { fullAddress: address, contact: {} }
            });
        });
    }

    render() {
        const styles = {
            cardHeader: {
                fontSize: '26px'
            },
            budgetTable: {
                marginTop: '2em'
            },
            budgetTableHeaderCell: {
            },
            budgetTableCell: {
                paddingBottom: '0'
            },
            budgetTableLabel: {
                whiteSpace: 'pre'
            }
        };

        const { monthlyBreakdown, company } = this.props;

        let budgetDetails = monthlyBreakdown ? (
            <Card.Content>
                <Card.Header><Header as='h2'>{i18next.t('budget')}</Header></Card.Header>
                <Card.Description>
                    <Table basic='very' celled width='10' style={styles.budgetTable}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell style={styles.budgetTableHeaderCell}>
                                    <Header as='h5' color='blue'>{i18next.t('currentPeriod')}</Header>
                                </Table.HeaderCell>
                                <Table.HeaderCell style={styles.budgetTableHeaderCell}>
                                    <Header as='h5' color='grey'>{i18next.t('previousPeriod')}</Header>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell style={styles.budgetTableCell}>
                                    <Label.Group color='blue' size='medium'>
                                        <Label style={styles.budgetTableLabel}>
                                            {i18next.t('utilized')}
                                            <Label.Detail>{formatPrice(monthlyBreakdown.currentMonthUsage, company.currency_code)}</Label.Detail>
                                        </Label>
                                        <Label style={styles.budgetTableLabel}>
                                            {i18next.t('loaded')}
                                            <Label.Detail>{formatPrice(monthlyBreakdown.loadedBudgetAmount, company.currency_code)}</Label.Detail>
                                        </Label>
                                    </Label.Group>
                                </Table.Cell>
                                <Table.Cell style={styles.budgetTableCell}>
                                    <Label.Group size='medium'>
                                        <Label style={styles.budgetTableLabel}>
                                            {i18next.t('utilized')}
                                            <Label.Detail>{formatPrice(monthlyBreakdown.previousMonthUsage, company.currency_code)}</Label.Detail>
                                        </Label>
                                    </Label.Group>

                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>

                    {/* <Label circular empty />
                    <Header as='h5' color='grey' style={styles.categoryHeader}>{i18next.t('previousPeriod')}</Header>
            
                    <Label circular color='blue' empty />
                    <Header as='h5' color='blue' style={styles.categoryHeader}>{i18next.t('currentPeriod')}</Header> */}

                </Card.Description>
            </Card.Content>
        ) : null;
        let companyDetailsCube = (
            <Card color='blue'>
                <Card.Content>
                    <Image floated='right' size='mini' src={company.imageUrl} />
                    <Card.Header style={styles.cardHeader}>{company.name}</Card.Header>
                    <Card.Meta>{i18next.t('company')}</Card.Meta>
                </Card.Content>
                {budgetDetails}
                <Card.Content extra>
                    <Icon name='map' />
                    {company.address}
                </Card.Content>
                <Card.Content extra>
                    <div className='ui two buttons'>
                        <Button basic primary onClick={this.editDeliveryInfo}>
                            {i18next.t(!company.deliveryInfo ? 'setDeliveryInfo' : 'editDeliveryInfo')}
                        </Button>
                    </div>
                </Card.Content>
            </Card>
        );

        if (!company.name) return null;

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('editDeliveryInfo')}
                    visible={this.props.onEdit}
                    handleClose={() => this.props.setEditedEntity(null)}
                >
                    <DeliveryEditor />
                </SideEditor>
                {companyDetailsCube}
            </div>
        );
    }
}

CompanyDetails.propTypes = {
    company: PropTypes.object,
    
    fetchMonthlyBreakdown: PropTypes.func,
    monthlyBreakdown: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    const { monthlyBreakdown } = state.budgetsApp;
    const onEdit = state.editor.type === 'company';

    const { companies } = state.budgetsApp;
    const company = companies.find(comp => comp.id === ownProps.match.params.companyId) || {};

    return { monthlyBreakdown, onEdit, company };
}
export default connect(mapStateToProps, { setEditedEntity, fetchMonthlyBreakdown })(CompanyDetails);
